import { render, staticRenderFns } from "./Trend.vue?vue&type=template&id=32356f0b&scoped=true&"
import script from "./Trend.vue?vue&type=script&lang=js&"
export * from "./Trend.vue?vue&type=script&lang=js&"
import style0 from "./Trend.vue?vue&type=style&index=0&id=32356f0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32356f0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32356f0b')) {
      api.createRecord('32356f0b', component.options)
    } else {
      api.reload('32356f0b', component.options)
    }
    module.hot.accept("./Trend.vue?vue&type=template&id=32356f0b&scoped=true&", function () {
      api.rerender('32356f0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Trend/Trend.vue"
export default component.exports